import { Card, Stack, Text, useTheme } from '@ltvco/refresh-lib/theme';
import { AutoAwesomeOutlined } from '@mui/icons-material';

import { parseNumericInput } from '../utils';

interface IAnalyzingStatusProps {
  budgetMin: string;
  budgetMax: string;
  vehicleType: string;
  usage: string;
}

export const AnalyzingStatus = ({
  budgetMin,
  budgetMax,
  vehicleType,
  usage,
}: IAnalyzingStatusProps) => {
  const theme = useTheme();
  const minBudget = parseNumericInput(budgetMin);
  const maxBudget = parseNumericInput(budgetMax);

  return (
    <Card variant="outlined" sx={{ width: 'fit-content', minWidth: '300px' }}>
      <Stack direction="row" alignItems="flex-start" gap={1}>
        <AutoAwesomeOutlined sx={{ color: theme.palette.primary.main }} />
        <Stack
          direction="column"
          alignItems="flex-start"
          gap={1}
          flexWrap="wrap"
        >
          <Text variant="body1">You&apos;re looking for:</Text>
          <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap">
            <Text
              variant="body1"
              bgcolor="primary.light"
              p={0.5}
              borderRadius={1}
              fontSize={{ xs: '0.825rem', md: '1rem' }}
            >
              {`$${minBudget} - $${maxBudget}`}
            </Text>
            {vehicleType && (
              <Text
                variant="body1"
                bgcolor="primary.light"
                p={0.5}
                borderRadius={1}
                fontSize={{ xs: '0.825rem', md: '1rem' }}
              >
                {vehicleType}
              </Text>
            )}
            {usage && (
              <Text
                variant="body1"
                bgcolor="primary.light"
                p={0.5}
                borderRadius={1}
                fontSize={{ xs: '0.825rem', md: '1rem' }}
              >
                {usage}
              </Text>
            )}
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );
};
